import * as React from "react";
import Login from "src/Backend/Login";

interface Props {
	onSuccessfulLogin: (res: any) => void;
	login: (password: string) => any;
	title: string;
}
export default class FightPageLogin extends React.Component<Props, {}> {
	public render() {
		return (
			<div>
				<Login
					onSuccessfulLogin={this.props.onSuccessfulLogin}
					login={this.props.login}
					title={this.props.title}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/FightPageLogin.tsx